import { default as MuiCircularProgress } from '@material-ui/core/CircularProgress';
import { Typography } from '@material-ui/core';
import CircularProgressWithLabel from '../CircularProgressWithLabel';
import Box from '@material-ui/core/Box';
import './ZaddonsCircularProgress.scss';

export default function ZaddonsCircularProgress(props) {
  const { label } = props;
  return (
    <Box className="zcp--root">
      { props.value !== undefined ? (
        <CircularProgressWithLabel
            size={props.size}
            value={props.value}
          />) : (
          <MuiCircularProgress {...props} />)
      }
      
      <Typography
        variant="caption"
        component="div"
        color="textSecondary"
        className="circular-progress-with-label--label"
      >
        {label}
      </Typography>
    </Box>
  );
}
